/**
 * Fetch project chart data
 * @param {string} projectID - Project ID to fetch data for
 * @returns {Promise<Array>} - Project data
 */
async function fetchProjectChartData(projectID) {
	console.log('fetchProjectChartData started');
	
	try {
		const response = await fetch(`/wp-admin/admin-ajax.php?action=fetch_project_data&projectId=${projectID}`, { cache: 'no-store' });
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
		const data = await response.json();
		
		if (data.success) {
			if (data.data.Items) {
				console.log('Items field in data:', data.data.Items);
				return data.data.Items;
			} else {
				console.log('No items field in data:', data);
			}
		} else {
			console.error('Error message from server:', data.data);
		}
	} catch (error) {
		console.error('Error fetching project data:', error);
	}
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = fetchProjectChartData;
} else if (typeof window !== 'undefined') {
	window.fetchProjectChartData = fetchProjectChartData;

	/**
	 * Toggle framework panel containers. On /home, WebAssessmentCharts.applyHomeScopedVisibility
	 * (from home-dashboard-registry.js) limits changes to the widget; on project pages,
	 * falls back to a global jQuery toggle (dashboard bundle has no registry).
	 */
	if (typeof window.applyFrameworkPanelVisibility !== 'function') {
		window.applyFrameworkPanelVisibility = function (jqueryMethod, selector) {
			if (window.WebAssessmentCharts && typeof WebAssessmentCharts.applyHomeScopedVisibility === 'function') {
				WebAssessmentCharts.applyHomeScopedVisibility(jqueryMethod, selector);
			} else {
				jQuery(selector)[jqueryMethod]();
			}
		};
	}
}
